import AdityaPhoenix1 from "../Assets/Aditya-Phoneix-1.jpeg";
import AdityaPhoenix2 from "../Assets/Aditya-Phoneix-2.jpeg";

const PhoenixPhotos = [
  {
    img: AdityaPhoenix1,
    alt: "Phoenix, AZ - Training session - 1",
  },
  {
    img: AdityaPhoenix2,
    alt: "Phoenix, AZ - Community play - 2",
  },
];

export default PhoenixPhotos;